module["exports"] = [
  "#{street_name} #{building_number}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ge/address/street_address.js
 ** module id = 625
 ** module chunks = 0
 **/